// Frame1 chỉ có tương tác nhẹ: đánh dấu mốc đã nhận khi click.
// Mốc là thẻ <a href="#"> nên phải chặn nhảy về đầu trang.
window.addEventListener("load", function () {
  const list = document.querySelectorAll("#frame1 .f1-milestone");
  list.forEach(function (item) {
    item.addEventListener("click", function (event) {
      event.preventDefault();
      if (item.classList.contains("received")) return;
      item.classList.add("received");
    });
  });
});
